import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _styled from "@emotion/styled-base";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import withProps from 'recompose/withProps';
import { getResponsiveStyles } from "../styles";
import Flex, { FlexItem } from "../Flex";
export var GridRoot = withProps({
  wrap: true
})(
/*#__PURE__*/
_styled(Flex, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['direction', 'inline', 'justifyContent'].indexOf(prop) === -1;
  },
  target: "e1wbdvuc0"
})({
  name: "k008qs",
  styles: "display:flex;"
}));

var getFlexGrow = function getFlexGrow(value) {
  return value ? 0 : 1;
};

var getWidth = function getWidth(value, columns, gutter) {
  return value ? "calc(" + value / columns * 100 + "% - " + gutter + ")" : 0;
};

export var GridItemRoot = withProps({
  shrink: 0
})(
/*#__PURE__*/
_styled(FlexItem, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['alignSelf', 'grow', 'inline', 'span', 'width'].indexOf(prop) === -1;
  },
  target: "e1wbdvuc1"
})(function (_ref) {
  var breakpoints = _ref.breakpoints,
      columns = _ref.columns,
      gutterWidth = _ref.gutterWidth,
      span = _ref.span,
      theme = _ref.theme;
  var gutter = typeof gutterWidth === 'number' ? gutterWidth + "px" : theme["space_inline_" + gutterWidth] || gutterWidth;

  var mapValueToProperty = function mapValueToProperty(property, value) {
    var map = {
      flexGrow: getFlexGrow,
      width: function width(value) {
        return getWidth(value, columns, gutter);
      }
    };
    return map[property](value);
  };
  /*
   * [1] IE11 doesn't use the correct box-sizing model with the flex-basis
   *     property. The workaround is to set flex-basis to 'auto' and use 'width'
   *     instead.
   */


  return _objectSpread({
    flexBasis: 'auto'
  }, getResponsiveStyles({
    breakpoints: breakpoints,
    mapValueToProperty: mapValueToProperty,
    styles: {
      flexGrow: span,
      width: span // [1]

    },
    theme: theme
  }));
}));